import React, { useState,useEffect } from "react";
import secureStorage from "@src/config/encrypt";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import FullPageLoader from '@src/common/FullPageLoader';
import ChangePasswordModal from './ChangePasswordModal';
import AddApplicationThankPopup from '@src/pages/insurance/AddApplicationThankPopup';
import ChangePasswordModalID from './ChangePasswordModalID';
import { COUNTRY_CODE } from '@src/config/constant';
import DeleteAccountConfirmModal from "@pages/DeleteAccountConfirmModal";
import { deleteAccountRequestID } from "@src/store/slices/user";
import AddApplicationThankPopupID from '@src/pages/insurance/AddApplicationThankPopupID';
import { useLanguage } from "@src/context/LanguageContext";
import { useDispatch } from "react-redux";
import { getUserDetail } from "@store/slices/commonId";
import BankDetailModal from "./BankDetailModal";

const Profile = () => {
 const isCountryId = COUNTRY_CODE ==='id' ? true : false;
    const navigate = useNavigate();
    const dispatch:any = useDispatch();
    const[userData , setUserData] = useState<any>('')
    const [loading, setLoading] = useState<boolean>(true);
    const [showChangePasswordPopup, setShowChangePasswordPopup] = useState<boolean>(false);
    const [showPasswordChnageSuccess, setShowPasswordChnageSuccess] = useState<boolean>(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showThankyouPopup, setShowThankyouPopup] = useState(false)
    const { setLanguage ,language,translations} = useLanguage();
    const [showBankModal,setShowBankModal] = useState(false)

    const handleClose = () => {
        setShowChangePasswordPopup(false);
    }

    const handleChangePassword = () => {
        setShowChangePasswordPopup(true);
    }

    const logOutUser = async () => {
        let result = secureStorage.getItem("authAgentUserInfo")
        if (result) {
            secureStorage.removeItem("authAgentUserInfo")
            toast.success('LogOut Successfully')
            setTimeout(() => { navigate('/login'); }, 100)
        }
    };

    const fetchUserData = () => {
        let result = secureStorage.getItem("authAgentUserInfo");
        setUserData(result.user_data);
        setLoading(false);
    };

    useEffect(() => {
        fetchUserData();
      } , [])

    const goToDeleteAcc = () => {
        if (COUNTRY_CODE) {
             setShowDeleteModal(true);
            //navigate('/delete/accountID');
        } else {
            navigate('/delete/account');
        }
    }

      const showSuccessPopup = (show_success_popup:boolean) => {
        setShowChangePasswordPopup(false);
        setShowPasswordChnageSuccess(show_success_popup);
      }

      const navigateToProfile = () => {
        setShowPasswordChnageSuccess(false);
        navigate("/my-profile");
      }

      const updateLastUpdatedPwd = (lastUpdatedPwd: string) => {
        setUserData((prevUserData: any) => {
            const updatedUserData = {
                ...prevUserData,
                last_updated_pwd: lastUpdatedPwd, // Update the last_updated_pwd in userData
            };
             // Update localStorage
             const authAgentUserInfo = secureStorage.getItem("authAgentUserInfo") || {};
             secureStorage.setItem("authAgentUserInfo", {
                 ...authAgentUserInfo,
                 user_data: updatedUserData,
             });
             return updatedUserData;
        });
    };

    // for ID delete account
    const deleteAccount = () => {
        //setLoading(true);
        
        setShowThankyouPopup(true);
        // delete api should implement here
        // const data = {
        //     email: "test@gmail.com",
        // };

        // deleteAccountRequestID(data)
        //     .then((res) => {
        //         if (res && res.data) {

        //             //  setShowVerify(false);      
        //             setShowDeleteModal(false);
        //         }
        //     })
        //     .finally(() => {
        //         setLoading(false);
        //     });
    };

    const deletePopupClose = () => {
        // close popup
        setShowThankyouPopup(false);

        secureStorage.removeItem("authAgentUserInfo")
        //toast.success('LogOut Successfully')
        setTimeout(() => { navigate('/login'); }, 100)
    };

    const handleLangChange=(lang:string)=>{
        secureStorage.setItem('lang',lang)
        setLanguage(lang);
    }
    const fetchUserDetailData = async (params: any={}) => {
        try {
            setLoading(true);
            let result = secureStorage.getItem("authAgentUserInfo");
            const payload:Record<string,any>={
                ...params,
                user_id: result?.user_data?.id
            }
            const response: any = await dispatch(getUserDetail(payload));
            if(response?.status===200){
                const updateUserData = {
                    ...userData,
                    ...response?.data
                }
                setUserData(updateUserData);
            }
            
            
        } catch (error) {
            console.error(error);
        }
        finally{
            setLoading(false);

        }
    }
    useEffect(() => {
        isCountryId &&
        fetchUserDetailData();
    },[])

    const handleCopy = (url: string) => {
        navigator.clipboard.writeText(url);
        toast.success("Referral code copied to clipboard");
    };

    return (
        <React.Fragment>
            <FullPageLoader show={loading} />
            {
                isCountryId ?
                 <ChangePasswordModalID show={showChangePasswordPopup} handleClose={handleClose} onSuccess={(response: any) => {
                    showSuccessPopup(response.show_success_popup);
                    updateLastUpdatedPwd(response.last_updated_pwd);
                }}></ChangePasswordModalID>
                :
                <ChangePasswordModal show={showChangePasswordPopup} handleClose={handleClose} onSuccess={(response: any) => {
                    showSuccessPopup(response.show_success_popup);
                    updateLastUpdatedPwd(response.last_updated_pwd);
                }}></ChangePasswordModal>
            }
             <AddApplicationThankPopup show={showPasswordChnageSuccess} handleClose={() => {
                    setShowPasswordChnageSuccess(false)
                }} screenType="CHANGE_PASSWORD" navigateToProfile={navigateToProfile}/>
            <div className="container-fluid profile-page">
                <div className="lead-top-heading p-lg-t">
                    <h1>My Profile</h1>
                </div>
                <div className="user-profile-outer m-lg-t">
                    <div className="row p-lg-t">
                        {/* Left side card */}
                        <div className="col-md-4 col-xs-12">
                            <div className="card profile-image-outer">
                                <div className="profile-img-container">
                                    <img
                                        src="/images/profile_icon.png"
                                        alt="Profile"
                                        className="profile-img rounded-circle"
                                    />
                                </div>
                                <span className="user-name">{userData?.name ?? ''}</span>
                                <span className="user-detail">ID - {userData?.user_id ?? ''}</span>
                                <span className="user-detail">{userData?.email ?? ''}</span>
                                <div className="profile-logout-container mt-4">
                                    <a href="#logout" onClick={logOutUser}>
                                        Logout
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Right side card */}
                        <div className="col-md-8 col-xs-12">
                            <div className="card user-profile-details">
                               
                                    <ul className="profile-info">
                                        <li>
                                            <span> {translations?.PROFILE?.NAME}:</span>
                                            <label>{userData?.name ?? ''}</label>
                                        </li>
                                         <li>
                                            <span> {translations?.PROFILE?.MOBILE_NO}:</span>
                                            <label>{userData?.mobile ?? ''}</label>
                                        </li>
                                        <li>
                                            <span> {translations?.PROFILE?.PROFILE_STATUS}:</span>
                                            <label className={`status-txt ${userData?.status ? 'status-active' : 'status-inactive'}`}>
                                                <i className={`ic-check ${userData?.status ? 'text-success' : 'text-danger'}`}></i>
                                                {userData?.status ? "Active" : "Inactive"}
                                            </label>
                                        </li>
                                        {
                                            isCountryId && (
                                                <> 
                                                    <li>
                                                    <span>{translations?.PROFILE?.NPWP}:</span>
                                                    <label>
                                                       {userData?.personal_detail?.npwp_no}
                                                    </label>
                                                    </li>

                                                     <li>
                                                    <span> {translations?.PROFILE?.ACCOUNT_MAK} {userData?.bank_detail?.mask_account_no}</span>
                                                    <label>
                                                       <i
                                                        className="ic-keyboard_arrow_right"
                                                        onClick={() => setShowBankModal(true)}
                                                        ></i>
                                                    </label>
                                                    </li>
                                                </>
                                            )
                                        }
                                        <li>
                                            <span>ID:</span>
                                            <label>{userData?.user_id ?? ''}</label>
                                        </li>
                                        <li>
                                            <span>{translations?.PROFILE?.EMAIL}:</span>
                                            <label>{userData?.email ?? ''}</label>
                                        </li>
                                        {
                                            isCountryId && (
                                                <div className="language-container">
                                                <span className="label">{translations?.PROFILE?.CHANGE_LANG}</span>

                                                <div className="toggle-wrapper">
                                                    <div
                                                    className={`toggle-btn ${language === "en" ? "active" : ""}`}
                                                    onClick={() => handleLangChange("en")}
                                                    >
                                                    ENG
                                                    </div>
                                                    <div
                                                    className={`toggle-btn ${language === "id" ? "active" : ""}`}
                                                    onClick={() => handleLangChange("id")}
                                                    >
                                                    BAHASA
                                                    </div>
                                                </div>
                                                </div>
                                            )
                                        }
                                        <li>
                                            <span><a href="#change-password"  onClick={(e) => {
                                                e.preventDefault();
                                                handleChangePassword();
                                            }}> {translations?.PROFILE?.CHANGE_PASSWORD}:</a></span>
                                            {
                                                userData?.last_updated_pwd &&
                                                <label>
                                                    Last Updated : {userData?.last_updated_pwd 
                                                                ? new Date(userData?.last_updated_pwd).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(',', '')
                                                                : ''}
                                                </label>
                                            }
                                        </li>
                                        <li>
                                            <span className="delete-txt" onClick={goToDeleteAcc}> {translations?.PROFILE?.DELETE_ACCOUNT}</span>
                                        </li>
                                        <li>
                                        <div className="referal_code">
                                            Referral Code : &nbsp;
                                            <span>{userData?.user_code}</span>
                                            <span className="txt-copy space-bw" onClick={() => handleCopy(userData?.user_code)}>
                                                <i className="ic-content_copy"></i>
                                            </span>
                                        </div>
                                        </li>
                                    </ul>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                showDeleteModal && <DeleteAccountConfirmModal show = {showDeleteModal} handleClose={() => { setShowDeleteModal(false)}} 
                onConfirm={deleteAccount} 
                />
            }
            {
                showBankModal && <BankDetailModal show={showBankModal} handleClose={() => setShowBankModal(false)} data={userData?.bank_detail} />
            }

            <AddApplicationThankPopupID show={showThankyouPopup} handleClose={deletePopupClose} screenType="DELETE_ACCOUNT"/>
        </React.Fragment>
    );
};

export default Profile;
